var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-h5 ma-4",attrs:{"fab":"","outlined":"","color":"white"},domProps:{"textContent":_vm._s(_vm.value)},on:{"click":function($event){_vm.$emit('click', String(_vm.value))}}})
}
var staticRenderFns = []

export { render, staticRenderFns }